import config from '../../config/config';
import { sessionAwareFetch } from './sessionAwareFetch';

async function parseReviewApiError(response) {
    let body = {};
    try {
        body = await response.json();
    } catch {
        /* non-JSON body */
    }
    const err = new Error(body.error || `HTTP error! status: ${response.status}`);
    err.status = response.status;
    return err;
}

export const reviewsService = {

    async getReviews(businessId, isPublished) {
        if (!businessId || typeof isPublished !== 'boolean') {
            throw new Error("Must provide a business ID and boolean isPublished");
        }

        const url = new URL(`${config.apimUrl}/review-api/`);
        url.searchParams.set("BusinessId", businessId);
        url.searchParams.set("IsPublished", String(isPublished));

        const response = await sessionAwareFetch(url.toString(), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': config.apimKeyReviewService,
            },
        });

        if (!response.ok) throw await parseReviewApiError(response);

        return await response.json();
    },

    /**
     * Admin: all reviews in one request. Pass IsReviewedByAdmin: false for triage queue only.
     */
    async getReviewsForAdmin({ IsReviewedByAdmin } = {}) {
        const url = new URL(`${config.apimUrl}/review-api/`);
        url.searchParams.set('Scope', 'admin');
        if (typeof IsReviewedByAdmin === 'boolean') {
            url.searchParams.set('IsReviewedByAdmin', String(IsReviewedByAdmin));
        }

        const response = await sessionAwareFetch(url.toString(), {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': config.apimKeyReviewService,
            },
        });

        if (!response.ok) throw await parseReviewApiError(response);

        return await response.json();
    },

    /** Signed-in user's existing review for a business (null if none). */
    async getMyReview(businessId) {
        if (!businessId) {
            throw new Error('Must provide a business ID');
        }

        const url = new URL(`${config.apimUrl}/review-api/`);
        url.searchParams.set('BusinessId', businessId);
        url.searchParams.set('MyReview', 'true');

        const response = await sessionAwareFetch(url.toString(), {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': config.apimKeyReviewService,
            },
        });

        if (!response.ok) throw await parseReviewApiError(response);
        return await response.json();
    },

    async createReview(businessId, reviewData) {
        const url = new URL(`${config.apimUrl}/review-api/`);

        const payload = {
            BusinessId: businessId,
            Rating: reviewData.Rating,
            ReviewText: reviewData.ReviewText || null,
        };

        const response = await sessionAwareFetch(url.toString(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': config.apimKeyReviewService,
            },
            credentials: 'include',
            body: JSON.stringify(payload),
        });

        return response;
    },

    async updateReviewDecision({ reviewId, businessId, action }) {
        if (!reviewId || !businessId || !action) {
            throw new Error('reviewId, businessId, and action are required');
        }

        const response = await sessionAwareFetch(`${config.apimUrl}/review-api/`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': config.apimKeyReviewService,
            },
            credentials: 'include',
            body: JSON.stringify({
                ReviewId: reviewId,
                BusinessId: businessId,
                Action: action,
            }),
        });

        if (!response.ok) throw await parseReviewApiError(response);
        return await response.json();
    }


};